import { AfterViewInit, ChangeDetectionStrategy, Component } from "@angular/core";
import { AgEditorComponent } from "@bfx/ag-grid-angular";
import { ICellEditorParams } from "ag-grid-community";
import { FwdRollBaseEditor } from "app/bfx-blotter-intervention/fwd-roll-pricing/editors/FwdRollBaseEditor";
import { FwdRollCurrencyModel } from "app/bfx-blotter-intervention/fwd-roll-pricing/models/FwdRollCurrencyModel";
import {
  AMOUNT_VALUE_ACCESSOR,
  NUMBER_SPINNER_INPUTS,
  NUMBER_SPINNER_VIEW_PROVIDERS,
} from "shared/base-components/number-spinner.component";

@Component({
  selector: "fwd-roll-mktpts-spinner",
  templateUrl: "../../../../shared/base-components/html/number-spinner.html",
  providers: [AMOUNT_VALUE_ACCESSOR],
  viewProviders: NUMBER_SPINNER_VIEW_PROVIDERS,
  inputs: NUMBER_SPINNER_INPUTS,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FwdRollMarketPtsEditor
  extends FwdRollBaseEditor
  implements AgEditorComponent, AfterViewInit
{
  public override agInit(params: ICellEditorParams): void {
    super.agInit(params);

    if (this.modelData instanceof FwdRollCurrencyModel) {
      // Once the cell is highlighted we disable the missing points class
      this.modelData.disableMissingPoints = true;
    }
  }

  protected override updateModelValue() {
    this.modelData.updateMarketForwardPts(this.data.value);
  }
}
